import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: {
    formSectionsSteps: [
      // {
      //        label: "Dividend Withholding Tax Declaration (DWT)",
      //        slug:  "dividend_withholding_tax_declaration",
      //        completed: false,
      //     },
    ],
    step: 0,
    failed: [],
    completed: [],
  },
};

export const formStepperSlice = createSlice({
  name: "stepper",
  initialState,
  reducers: {
    updateFormStepperSteps: (state, action) => {
      const newFormSteps = [];
      action.payload.forEach((slug) => {
        newFormSteps.push({ slug: slug, completed: false });
      });
      state.value.formSectionsSteps = newFormSteps;
    },
    completeFormStep: (state, action) => {
      const step = state.value.formSectionsSteps.findIndex(
        (x) => x.slug === action.payload
      );
      state.value.formSectionsSteps[step].completed = true;
    },
    changeStep: (state, action) => {
      state.value.step = action.payload;
    },
    resetSteps: () => initialState,
  },
});

export const {
  changeStep,
  resetSteps,
  completeFormStep,
  updateFormStepperSteps,
} = formStepperSlice.actions;

export default formStepperSlice.reducer;
